import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconPhone(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.925 11.28a.669.669 0 0 0-.567-.692 9.231 9.231 0 0 1-2.021-.504.666.666 0 0 0-.701.147l-.847.847a.667.667 0 0 1-.801.108 11.333 11.333 0 0 1-4.25-4.25.667.667 0 0 1 .108-.801l.844-.844a.666.666 0 0 0 .149-.705 9.215 9.215 0 0 1-.502-2.013A.668.668 0 0 0 4.664 2H2.665A.667.667 0 0 0 2 2.716a12.532 12.532 0 0 0 1.946 5.493 12.34 12.34 0 0 0 3.8 3.798 12.512 12.512 0 0 0 5.451 1.942.668.668 0 0 0 .727-.67zm1.334 1.997a2.002 2.002 0 0 1-2.192 1.999 13.856 13.856 0 0 1-6.039-2.147 13.67 13.67 0 0 1-4.202-4.2A13.864 13.864 0 0 1 .675 2.847c-.051-.559.136-1.114.515-1.528S2.104.668 2.666.667h1.993A2.002 2.002 0 0 1 6.66 2.393c.078.59.222 1.17.43 1.726a2 2 0 0 1-.453 2.113l-.478.478a9.996 9.996 0 0 0 3.057 3.057l.481-.481a2 2 0 0 1 2.108-.451 7.937 7.937 0 0 0 1.733.431 2 2 0 0 1 1.72 2.021z"
  }));
}
IconPhone.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconPhone.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconPhone as default };
